
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SidebarLinkComponent',
    props: {
        title: {
            type: String,
            required: true
        }, 
        obj: {
            type: Object,
            required: true
        }
    }
})
